/* =============================================================================
   Elos Link - ordenacao e filtro das modalidades de frete
   Solicitacao 05cc7a50

   Regra acordada com o lojista:
   1. ordena da mais barata para a mais cara; empate de preco -> menor prazo antes
   2. oculta a opcao que for, ao mesmo tempo, mais cara E mais demorada que outra
      ja exibida (o cliente nunca escolheria pagar mais para receber depois)
   3. empate de prazo e mantido (ex.: Sedex pago com o mesmo prazo do frete gratis)
   4. opcao sem prazo informado e sempre mantida
   5. a lista nunca fica vazia

   Consumida por assets/custom.js (carrinho) e assets/quickShipping.js (produto).
   ============================================================================= */
(function () {
  "use strict";

  function precoDe(rate) {
    var valor = parseFloat(rate && rate.price);
    return isNaN(valor) ? Infinity : valor;
  }

  /* Usa o MESMO campo que o site exibe (delivery_days[1]), para o filtro nunca
     esconder uma opcao por causa de um prazo que o cliente nao veria na tela. */
  function prazoDe(rate) {
    var dias = rate && rate.delivery_days;
    var valor = dias ? parseInt(dias[1], 10) : NaN;
    return isNaN(valor) || valor <= 0 ? null : valor;
  }

  window.EL_fretesRelevantes = function (rates) {
    if (!rates || !rates.length) {
      return rates || [];
    }

    var ordenados = Array.prototype.slice.call(rates).sort(function (a, b) {
      var diff = precoDe(a) - precoDe(b);
      if (diff !== 0) {
        return diff;
      }
      var prazoA = prazoDe(a);
      var prazoB = prazoDe(b);
      if (prazoA === prazoB) {
        return 0;
      }
      if (prazoA === null) {
        return 1;
      }
      if (prazoB === null) {
        return -1;
      }
      return prazoA - prazoB;
    });

    var menorPrazo = null;
    var visiveis = [];

    for (var i = 0; i < ordenados.length; i++) {
      var prazo = prazoDe(ordenados[i]);

      if (prazo === null) {
        visiveis.push(ordenados[i]);
        continue;
      }

      if (menorPrazo === null || prazo <= menorPrazo) {
        menorPrazo = prazo;
        visiveis.push(ordenados[i]);
      }
    }

    return visiveis.length ? visiveis : ordenados.slice(0, 1);
  };
})();
